import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms-2-26',
    templateUrl: './salary-forms-2-26.component.html',
    styleUrl: './salary-forms-2-26.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryForms226Component {
  constructor(
  ) {
  }
}
